import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_services/alert.service';
import { PaymentGatewayService } from '../payment-gateway-service';

export interface Merchant {
  payId: string;
  businessName: string;
}

export interface Currency {
  code: string;
  name: string;
}

export interface PaymentType {
  code: string;
  name: string;
}

@Component({
  selector: 'app-frm',
  templateUrl: './frm.component.html',
  styleUrls: ['./frm.component.scss']
})
export class FrmComponent implements OnInit {

  setTicketLimit($event: Event) {
    throw new Error('Method not implemented.');
  }
  frmForm: FormGroup;
  merchants: Merchant[] = [];
  currencies: Currency[] = [];
  paymentTypes: PaymentType[] = [];
  selectedMerchant: string = '';
  selectedCurrency: string = '';
  selectedPaymentType: string = '';
  frmDetails: any;
  loading = false;
  remainingAmount: number = 0;
  currencySymbol: string = '';
  remainingWeeklyAmount: number = 0;
  remainingMonthlyAmount: number = 0;
  remainingDailyTransactions: number = 0;
  remainingWeeklyTransactions: number = 0;
  remainingMonthlyTransactions: number = 0;

  constructor(
    private fb: FormBuilder,
    private merchantBillingService: PaymentGatewayService,
    private alertService: AlertService
  ) {
    this.frmForm = this.fb.group({
      merchantPayId: ['', Validators.required],
      mop: ['', Validators.required],
      minTicketSize: [''],
      maxTicketSize: [''],
      mopDaily: [''],
      mopWeekly: [''],
      mopMonthly: [''],
      daily: [''],
      weekly: [''],
      monthly: [''],
      merchantProfile: ['', Validators.required]

    });
  }


  ngOnInit(): void {
    this.frmForm.get('maxAmountPerDay')?.valueChanges.subscribe(value => {
      this.remainingAmount = value;
    });
    this.frmForm.get('maxAmountPerWeek')?.valueChanges.subscribe(value => {
      this.remainingWeeklyAmount = value;
    });
    this.frmForm.get('maxAmountPerMonth')?.valueChanges.subscribe(value => {
      this.remainingMonthlyAmount = value;
    });
    this.frmForm.get('maxTransactionCountPerDay')?.valueChanges.subscribe(value => {
      this.remainingDailyTransactions = value;
    });
    this.frmForm.get('maxTransactionCountPerWeek')?.valueChanges.subscribe(value => {
      this.remainingWeeklyTransactions = value;
    });

    this.frmForm.get('maxTransactionCountPerMonth')?.valueChanges.subscribe(value => {
      this.remainingMonthlyTransactions = value;
    });
    this.getMerchants();
  }
  getMerchants(): void {
    this.merchantBillingService.getAllMerchants().subscribe((merchants: any) => {
      this.merchants = merchants;
    }, error => {
      this.alertService.errorAlertWithMessage('Error fetching merchants');
    });
  }

  onMerchantChange(selectedValue: string): void {
    console.log("call to load currency:");
    this.selectedMerchant = selectedValue;
    // this.loadCurrencies();
    this.loadPaymentTypesAndLimits();
    // this.loadTransactionLimits();
  }


  loadCurrencies(): void {
    console.log(":::::::moni");
    this.merchantBillingService.getCurrencyListTdr(this.selectedMerchant).subscribe((response: any) => {
      this.currencies = Object.keys(response.payload).map(code => ({
        code,
        name: response.payload[code]
      }));
    }, error => {
      this.alertService.errorAlertWithMessage('Error fetching currency list');
    });
  }

  onCurrencyChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.selectedCurrency = target.value;
    this.loadPaymentTypesAndLimits();
    this.loadTransactionLimits();
  }

  loadTransactionLimits(): void {
    this.merchantBillingService.setTicketLimit(this.selectedMerchant, "356").subscribe((response: any) => {
      const ticketDetails = response.payload[0] || {};

      console.log("Ticket Details:", ticketDetails);
      console.log("Min Amount:", ticketDetails.minTransactionAmount);
      console.log("Max Amount:", ticketDetails.maxTransactionAmount);

      this.frmForm.patchValue({
        minTransactionAmount: ticketDetails.minTransactionAmount,
        maxTransactionAmount: ticketDetails.maxTransactionAmount,
        merchantProfile: ticketDetails.merchantProfile
      });
    }, error => {
      this.alertService.errorAlertWithMessage('Error fetching transaction limits');
    });
  }

  id: string;
  ticketId: string;
  volumeId: string;
  loadPaymentTypesAndLimits(): void {
    this.merchantBillingService.getPaymentTypesN(this.selectedMerchant, "356").subscribe((response: any) => {
      if (response && response.payload) {
        const frmDetails = response.payload.frmDetails[0];
        this.frmDetails = response.payload.frmDetails;
        const paymentMap = response.payload.paymentMap || {};
        this.paymentTypes = Object.keys(paymentMap).map((key: string) => ({
          code: key,
          name: paymentMap[key]
        }));
        if (frmDetails) {
          this.id = frmDetails.id;
          this.frmForm.get('mopDaily')?.setValue(frmDetails.dailyAmount);
          this.frmForm.get('mopWeekly')?.setValue(frmDetails.weeklyAmount);
          this.frmForm.get('mopMonthly')?.setValue(frmDetails.monthlyAmount);
        }
        this.currencySymbol = response.payload.currencySymbol || '';
      } else {
        this.frmDetails = undefined;
      }
    }, error => {
      this.frmDetails = undefined;
      this.alertService.errorAlertWithMessage('Error fetching payment types');
    });

    this.merchantBillingService.setTicketLimit(this.selectedMerchant, "356").subscribe((response: any) => {
      const ticketDetails = response.payload[0] || {};
      if (ticketDetails) {
        this.ticketId = ticketDetails.id;
        this.frmForm.get('minTicketSize')?.setValue(ticketDetails.minTransactionAmount);
        this.frmForm.get('merchantProfile')?.setValue(ticketDetails.merchantProfile);
        this.frmForm.get('maxTicketSize')?.setValue(ticketDetails.maxTransactionAmount);
      }
      // this.frmForm.patchValue({
      //   minTicketSize: ticketDetails.minTicketSize,
      //   maxTicketSize: ticketDetails.maxTicketSize,
      //   dailyTransactionLimit: ticketDetails.dailyTransactionLimit,
      //   weeklyTransactionLimit: ticketDetails.weeklyTransactionLimit,
      //   monthlyTransactionLimit: ticketDetails.monthlyTransactionLimit
      // });
    }, error => {
      this.alertService.errorAlertWithMessage('Error fetching ticket limits');
    });
  }
  // loadPaymentTypesAndLimits(): void {
  //   this.merchantBillingService.getFrmDetails(this.selectedMerchant, "356").subscribe((response: any) => {
  //     if (response && response.payload) {
  //       const frmDetails = response.payload.frmDetails;
  //       const paymentMap = response.payload.paymentMap || {};
  //       this.paymentTypes = frmDetails.map((detail: any) => ({
  //         code: detail.paymentType,
  //         name: paymentMap[detail.paymentType] || detail.paymentType
  //       }));
  //       this.currencySymbol = response.payload.currencySymbol || '';
  //     }
  //   }, error => {
  //     this.alertService.error('Error fetching payment types');
  //   });

  //   this.merchantBillingService.setTicketLimit(this.selectedMerchant, "356").subscribe((response: any) => {
  //     const ticketDetails = response.payload || {};
  //     this.frmForm.patchValue({
  //       minTicketSize: ticketDetails.minTicketSize,
  //       maxTicketSize: ticketDetails.maxTicketSize,
  //       dailyTransactionLimit: ticketDetails.dailyTransactionLimit,
  //       weeklyTransactionLimit: ticketDetails.weeklyTransactionLimit,
  //       monthlyTransactionLimit: ticketDetails.monthlyTransactionLimit
  //     });
  //   }, error => {
  //     this.alertService.error('Error fetching ticket limits');
  //   });
  // }

  onPaymentTypeChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.selectedPaymentType = target.value;
    this.loadFrmDetails();
  }

  loadFrmDetails(): void {
    this.merchantBillingService.getFrmDetailsByVolume(this.selectedMerchant, "356", this.selectedPaymentType)
      .subscribe((response: any) => {
        if (response && response.payload && response.payload.length > 0) {
          const details = response.payload[0];
          if (details) {
            this.volumeId = details.id;
            this.frmForm.get('daily')?.setValue(details.dailyAmount || 0);
            this.frmForm.get('monthly')?.setValue(details.monthlyAmount || 0);
            this.frmForm.get('weekly')?.setValue(details.weeklyAmount || 0);
          }
          // this.frmForm.patchValue({
          //   daily: details.dailyAmount || 0,
          //   weeklyAmount: details.weeklyAmount || 0,
          //   monthly: details.monthlyAmount || 0,
          //   // maxTransactionCountPerDay: details.displayDailyVolumeQuota || 0,
          //   // maxTransactionCountPerWeek: details.displayWeeklyVolumeQuota || 0,
          //   // maxTransactionCountPerMonth: details.displayMonthlyVolumeQuota || 0
          // });
        } else {
          // this.alertService.error('No FRM details found');
        }
      }, error => {
        this.alertService.errorAlertWithMessage('Error fetching FRM details');
      });
  }

  saveFrmDetails(): void {
    if (this.frmForm.valid) {
      this.loading = true;
      let isExists = this.frmDetails.some((payment: any) => payment.paymentType === this.frmForm.value.mop);
      let obj = {
        selectedCurrencyCode: '356',
        ...this.frmForm.value,
        ...(isExists && { id: this.id }),
        ...((this.ticketId && this.volumeId) && { ticketId: this.ticketId, volumeId: this.volumeId })
      }
      this.merchantBillingService.saveFrmDetails(obj).subscribe(
        (response) => {
          this.alertService.successAlertWithMessage('FRM details saved successfully');
          this.loading = false;
          this.frmForm.reset();
          window.location.reload();

        },
        (error) => {
          this.alertService.errorAlertWithMessage('Error saving FRM details');
          this.loading = false;
          window.location.reload();
        }
      );
    } else {
      this.alertService.errorAlertWithMessage('Please fill in all required fields');
      window.location.reload();
    }
  }

}
